if (process.env.BUILD_GC === 'store' || process.env.BUILD_GC === 'cicp') {
  module.exports = require('./store')
} else {
  module.exports = null
}
